import styled from 'styled-components'
import ActivationButton from './ActivationButton'
import Agent from 'components/Agent'
import { useState } from 'react'
import { RxCross2 } from "react-icons/rx"

const Bot = () => {
  const [showAgent, setShowAgent] = useState(false)

  return (
    <Container>
      <TextWidth>
      <Agent handleHideAgent={() => {}} />
        {/* <div style={{display:'flex', alignItems: 'flex-end', flexDirection: 'column'}}>
        {showAgent && <CloseButton onClick={() => {setShowAgent(false)}}><RxCross2 /></CloseButton>}
        {showAgent && <Agent />}
        {!showAgent && <Content>
          <ActivationButton onClick={(state) => {setShowAgent(state)}} />
        </Content>}
        </div> */}
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
position: relative;
`

const CloseButton = styled.div`
color: ${({ theme }) => theme.primaryButtonText};
cursor: pointer;
border-radius: 50px;
background-color: ${({ theme }) => theme.primaryButtonBackground};
height: 50px;
width: 50px;
display: flex;
align-items: center;
justify-content: center;
overflow: hidden;
position: relative;
transform: translate(15px, 30px);
`

const Content = styled.div`
  display: flex;
  justify-content: flex-end;
`

const TextWidth = styled.div`
  margin: 0 auto;
  max-width: 666px;
`

export default Bot
